import { State } from "../model/state";
import { apiSlice } from "../stores/base/api-slice";

const statesEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getStates: builder.query<State[], void>({
			query: () => ({
				url: "/states",
				method: "GET",
			})
		}),
		getStatesByCountry: builder.query<State[], string>({
			query: (countryCode) => ({
				url: `/states?countryIsoCode=${countryCode}`,
				method: "GET",
			})
		}),
	})
});

export const {
	useLazyGetStatesQuery,
	useGetStatesQuery,
	useLazyGetStatesByCountryQuery,
	useGetStatesByCountryQuery,
} = statesEndpoints;
